var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSpace = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59138 16.5583C7.46406 16.5583 7.33891 16.5252 7.22812 16.4622L0.964964 12.9004C0.734089 12.7691 0.591385 12.5233 0.591385 12.2569V4.85967C0.591385 4.59327 0.734089 4.34745 0.964964 4.21611L7.22812 0.654366C7.4535 0.526324 7.72926 0.526324 7.95465 0.654366L14.2178 4.21611C14.4487 4.34745 14.5914 4.59327 14.5914 4.85967V12.2569C14.5914 12.5233 14.4487 12.7691 14.2178 12.9004L7.95465 16.4622C7.84386 16.5252 7.71871 16.5583 7.59138 16.5583ZM2.06507 11.8256L7.59138 14.9679L13.1177 11.8256V5.29093L7.59138 2.1486L2.06507 5.29019V11.8256Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06508 11.8256L7.59139 14.9679L13.1177 11.8256V5.29093L7.59139 2.1486L2.06508 5.29019V11.8256Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSpace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/space.43c86376b247a608ac66f21676745c17.svg";